import { Routes, CanActivate } from "@angular/router";
import { AuthGuardService } from "./main/auth/auth-guard.service";
import { RoleGuardService } from "./main/auth/role-guard.service";

import { LoginComponent } from "./main/login/login.component";
import { UsuariosComponent } from "./main/apps/usuarios/usuarios.component";
import { ObjetivosComponent } from "./main/apps/objetivos/objetivos.component";
import { ControlComponent } from "./main/apps/control/control.component";

import { DimensionesRiesgosComponent } from "./main/apps/dimensiones-riesgos/dimensiones-riesgos.component";
import { TipoEvaluacionComponent } from "./main/apps/tipo-evaluacion/tipo-evaluacion.component";
import { TablaDeEvaluacionComponent } from "./main/apps/tabla-de-evaluacion/tabla-de-evaluacion.component";
import { MarcoDeReferenciaComponent } from "./main/apps/marco-de-referencia/marco-de-referencia.component";
import { RiesgoComponent } from "./main/apps/riesgo/riesgo.component";
import { EstructuraJerarquicaComponent } from "./main/apps/estructura-jerarquica/estructura-jerarquica.component";
import { FactorPonderacionComponent } from "./main/apps/factor-ponderacion/factor-ponderacion.component";
import { ReglaBaseComponent } from "./main/apps/regla-base/regla-base.component";
import { EscenarioComponent } from "./main/apps/escenario/escenario.component";
import { EvaluacionComponent } from "./main/apps/evaluacion/evaluacion.component";
import { EvaluacionListadoPrintComponent } from "./main/apps/evaluacion/evaluacion-listado-print.component";
import { EvaluacionControlesSugeridosPrintComponent } from "./main/apps/evaluacion/evaluacion-controles-sugeridos-print.component";
import { EvaluacionMedidasDeContingenciaPrintComponent } from "./main/apps/evaluacion/evaluacion-medidas-de-contingencia-print.component";
import { EvaluacionKrisPrintComponent } from "./main/apps/evaluacion/evaluacion-kris-print.component";
import { EvaluacionControlesCriticosPrintComponent } from "./main/apps/evaluacion/evaluacion-controles-criticos-print.component";

import { EvaluacionViewComponent } from "./main/apps/evaluacion/evaluacion-view.component";
import { PreiniciarEvaluacionComponent } from "./main/apps/evaluacion/preiniciar-evaluacion.component";
import { ConsolidarEvaluacionComponent } from "./main/apps/evaluacion/consolidar-evaluacion.component";
import { ConsolidacionViewComponent } from "./main/apps/evaluacion/consolidacion-view.component";
import { ConsolidacionComponent } from "./main/apps/evaluacion/consolidacion.component";
import { MisConsolidacionesComponent } from "./main/apps/evaluacion/mis-consolidaciones.component";
import { MisEvaluacionesComponent } from "./main/apps/evaluacion/mis-evaluaciones.component";
import { TipoUsuarioComponent } from "./main/apps/tipo-usuario/tipo-usuario.component";
import { KriComponent } from "./main/apps/kri/kri.component";
import { MisKriComponent } from "./main/apps/kri/mis-kri.component";
import { AuditoriasComponent } from "./main/apps/auditorias/auditorias.component";
import { CumplimientoComponent } from "./main/apps/cumplimiento/cumplimiento.component";
import { DashboardComponent } from "./main/apps/dashboard/dashboard.component";

import { IniciarAnalisisDeBrechasComponent } from "./main/apps/analisis-de-brechas/iniciar-analisis.component";
import { AnalisisDeBrechasComponent } from "./main/apps/analisis-de-brechas/analisis-de-brechas.component";
import { MisAnalisisDeBrechasComponent } from "./main/apps/analisis-de-brechas/mis-analisis-de-brechas.component";
import { AnalisisDeBrechasViewComponent } from "./main/apps/analisis-de-brechas/analisis-de-brechas-view.component";
import { IniciarDebidaDiligenciaComponent } from "./main/apps/debida-diligencia/iniciar-debida-diligencia.component";
import { DebidaDiligenciaComponent } from "./main/apps/debida-diligencia/debidas-diligencias.component";
import { MisDebidaDiligenciaComponent } from "./main/apps/debida-diligencia/mis-debida-diligencias.component";
import { DebidaDiligenciaViewComponent } from "./main/apps/debida-diligencia/debida-diligencia-view.component";
import { SujetoObligadoComponent } from "./main/apps/debida-diligencia/sujeto-obligado/sujetos-obligados.component";
import { TipoSujetoObligadoComponent } from "./main/apps/debida-diligencia/tipo-sujeto-obligado/tipo-sujeto-obligado.component";
import { ProfesionComponent } from "./main/apps/debida-diligencia/profesion/profesion.component";
import { SectorActividadComponent } from "./main/apps/debida-diligencia/actividad-sector/actividad-sector.component";
import { TipoOperacionComponent } from "./main/apps/debida-diligencia/tipo-operacion/tipo-operacion.component";
import { TipoDocumentoComponent } from "./main/apps/debida-diligencia/tipo-documento/tipo-documento.component";
import { SujetoObligadoViewComponent } from "./main/apps/debida-diligencia/sujeto-obligado/sujeto-obligado-view.component";
import { MonedaComponent } from "./main/apps/debida-diligencia/moneda/moneda.component";
import { PaisComponent } from "./main/apps/debida-diligencia/pais/pais.component";
import { ClienteSujetoObligadoViewComponent } from "./main/apps/debida-diligencia/sujeto-obligado/cliente/cliente-sujeto-obligado-view.component";
import { DebidaDiligenciaViewExternalComponent } from "./main/apps/debida-diligencia/debida-diligencia-external-view.component";
import { ClienteSujetoObligadoExternalViewComponent } from "./main/apps/debida-diligencia/sujeto-obligado/cliente/cliente-sujeto-obligado-external-view.component";
import { FormularioComponent } from "./main/apps/debida-diligencia/formulario/formulario.component";
import { DebidaDiligenciaFormViewComponent } from "./main/apps/debida-diligencia/debida-diligencia-form-view.component";
import { OrigenDeFondosComponent} from './main/apps/debida-diligencia/origen-de-fondos/origen-de-fondos.component';
import {
    PonderacionDeRiesgosComponent
} from './main/apps/debida-diligencia/ponderacion-de-riesgos/ponderacion-de-riesgos.component';

export const appRoutes: Routes = [
    {
        path: "auth/login",
        component: LoginComponent,
    },

    {
        path: "dashboard",
        component: DashboardComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: "usuarios",
        component: UsuariosComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [2, 4],
        },
    },
    {
        path: "tipo-usuarios",
        component: TipoUsuarioComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: "objetivos",
        component: ObjetivosComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [2, 4, 5],
        },
    },
    {
        path: "controles",
        component: ControlComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [1, 2, 4, 5],
        },
    },

    {
        path: "dimensiones-riesgos",
        component: DimensionesRiesgosComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [2, 4, 5],
        },
    },
    {
        path: "reglas-base",
        component: ReglaBaseComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [1, 2, 4, 5, 6],
        },
    },

    {
        path: "riesgos",
        component: RiesgoComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [2, 4, 5],
        },
    },
    {
        path: "factores-de-ponderacion",
        component: FactorPonderacionComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [2, 4, 5],
        },
    },
    {
        path: "tipos-evaluacion",
        component: TipoEvaluacionComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: "marcos-de-referencia",
        component: MarcoDeReferenciaComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [1, 2, 4, 5, 6],
        },
    },
    {
        path: "tablas-de-evaluacion",
        component: TablaDeEvaluacionComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [2, 4, 5, 6],
        },
    },
    {
        path: "tablas-de-evaluacion-debida-diligencia",
        component: TablaDeEvaluacionComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [2, 4, 5, 6],
        },
    },
    {
        path: "estructuras-jerarquicas",
        component: EstructuraJerarquicaComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [1, 2, 3, 4, 5],
        },
    },
    {
        path: "escenario",
        component: EscenarioComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [2, 4, 1, 5],
        },
    },
    {
        path: "todas-las-evaluaciones",
        component: EvaluacionComponent,
        canActivate: [AuthGuardService],
    },

    {
        path: "seguimiento-de-kri",
        component: KriComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: "mis-kri",
        component: MisKriComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [2, 3, 4],
        },
    },
    {
        path: "evaluacion/:id",
        component: EvaluacionViewComponent,
        canActivate: [AuthGuardService],
    },

    {
        path: "preiniciar-evaluacion",
        component: PreiniciarEvaluacionComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [2, 4, 5],
        },
    },
    {
        path: "mis-evaluaciones",
        component: MisEvaluacionesComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [2, 3, 4, 5],
        },
    },
    {
        path: "listado-detallado-de-la-evaluacion",
        component: EvaluacionListadoPrintComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [1, 2, 3, 4, 5],
        },
    },
    {
        path: "listado-de-controles-sugeridos",
        component: EvaluacionControlesSugeridosPrintComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [1, 2, 3, 4, 5],
        },
    },
    {
        path: "listado-controles-criticos",
        component: EvaluacionControlesCriticosPrintComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [1, 2, 3, 4, 5],
        },
    },
    {
        path: "listado-de-medidas-de-contingencia",
        component: EvaluacionMedidasDeContingenciaPrintComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [1, 2, 3, 4, 5],
        },
    },
    {
        path: "listado-de-kri",
        component: EvaluacionKrisPrintComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [1, 2, 3, 4, 5],
        },
    },
    {
        path: "consolidar",
        component: ConsolidarEvaluacionComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [2, 4, 5],
        },
    },
    {
        path: "consolidacion/:id",
        component: ConsolidacionViewComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [1, 2, 3, 4, 5],
        },
    },
    {
        path: "todas-las-evaluaciones-consolidadas",
        component: ConsolidacionComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [1, 2, 3, 4, 5],
        },
    },
    {
        path: "mis-evaluaciones-consolidadas",
        component: MisConsolidacionesComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [1, 2, 3, 4, 5],
        },
    },
    {
        path: "ver-pistas-de-auditoria",
        component: AuditoriasComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [1, 2, 4, 5],
        },
    },
    {
        path: "listado-de-cumplimiento",
        component: CumplimientoComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [2, 4, 5, 6],
        },
    },
    {
        path: "iniciar-analisis-de-brechas",
        component: IniciarAnalisisDeBrechasComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [2, 4, 5, 6, 7],
        },
    },
    {
        path: "analisis-de-brechas/:id",
        component: AnalisisDeBrechasViewComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [1, 2, 5, 6, 7],
        },
    },
    {
        path: "todos-los-analisis-de-brechas",
        component: AnalisisDeBrechasComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [1, 2, 5, 6, 7],
        },
    },
    {
        path: "mis-analisis-de-brechas",
        component: MisAnalisisDeBrechasComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [2, 5, 6, 7],
        },
    },
    {
        path: "iniciar-debida-diligencia",
        component: IniciarDebidaDiligenciaComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [2, 4, 5, 6, 7],
        },
    },
    {
        path: "debida-diligencia/:uuid",
        component: DebidaDiligenciaViewComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [2, 5, 6, 7, 8],
        },
    },
    {
        path: "debida-diligencia/:uuid/form/:id",
        component: DebidaDiligenciaFormViewComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [2, 5, 6, 7, 8],
        },
    },
    {
        path: "debida-diligencia/:uuid/form/:id/external",
        component: DebidaDiligenciaViewExternalComponent,
    },
    {
        path: "todas-las-debidas-diligencias",
        component: DebidaDiligenciaComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [2, 5, 6, 7],
        },
    },
    {
        path: "mis-debidas-diligencias",
        component: MisDebidaDiligenciaComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [2, 5, 6, 7],
        },
    },
    {
        path: "sujeto-obligado-debidas-diligencias",
        component: SujetoObligadoComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [2, 5, 6, 7],
        },
    },
    {
        path: "tipo-sujeto-obligado-debidas-diligencias",
        component: TipoSujetoObligadoComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [2, 5, 6, 7],
        },
    },
    {
        path: "tipo-operacion-debidas-diligencias",
        component: TipoOperacionComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [2, 5, 6, 7],
        },
    },
    {
        path: "origen-de-fondos-debida-diligencia",
        component: OrigenDeFondosComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [2, 5, 6, 7],
        },
    },
    {
        path: "ponderacion-de-riesgos-debida-diligencia",
        component: PonderacionDeRiesgosComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [2, 5, 6, 7],
        },
    },
    {
        path: "profesion-sujeto-obligado-debida-diligencia",
        component: ProfesionComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [2, 5, 6, 7],
        },
    },
    {
        path: "sector-actividad-sujeto-obligado-debida-diligencia",
        component: SectorActividadComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [2, 5, 6, 7],
        },
    },
    {
        path: "tipo-de-documento-debida-diligencia",
        component: TipoDocumentoComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [2, 5, 6, 7],
        },
    },
    {
        path: "moneda-debida-diligencia",
        component: MonedaComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [2, 5, 6, 7],
        },
    },
    {
        path: "pais-debida-diligencia",
        component: PaisComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [2, 5, 6, 7],
        },
    },
    {
        path: "formularios-debida-diligencia",
        component: FormularioComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRole: [2, 5, 6, 7],
        },
    },
    {
        path: "sujeto-obligado/:id",
        component: SujetoObligadoViewComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: "operaciones-debida-diligencia",
        component: SujetoObligadoViewComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: "sujeto-obligado/:idSujetoObligado/cliente/:id",
        component: ClienteSujetoObligadoViewComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: "cliente/:uuid/external",
        component: ClienteSujetoObligadoExternalViewComponent,
    },
    {
        path: "**",
        redirectTo: "dashboard",
    },
];
